<template>
  <div class="cuerpo-historial">
    <div class="contenedor-datos">
      <div class="btn-inicio-hisotrial">
        <button @click="clickHome()">
          <img :src="urlFlecha" />
          INICIO
        </button>
      </div>
      <img
        class="logo-historial"
        :src="model.urlImagenPrincipal"
        alt="logo ilustrativo"
      />
      <h2 class="titulo">REGISTRO de BENEFICIOS</h2>
      <div class="fecha-historial">
        <div>
          <div class="box-fecha">
            <input
              v-model="model.startDate"
              @change="startDateChanged()"
              @click="mostrarFechaDesde()"
              id="fecha-desde"
              type="date"
              class="form-control"
            />
            <img class="cunia" :src="urlCunia" />
          </div>

          <label for="fecha-desde">DESDE</label>
        </div>
        <div>
          <div class="box-fecha">
            <input
              v-model="model.endDate"
              @change="endDateChanged()"
              @click="mostrarFechaHasta()"
              id="fecha-hasta"
              type="date"
              class="form-control"
            />
            <img class="cunia" :src="urlCunia" />
          </div>

          <label for="fecha-hasta">HASTA</label>
        </div>
      </div>

      <div v-if="!model.loading">
        <div v-if="!model.isEmpty">
          <div class="table-responsive">
            <table class="table tabla-historial">
              <thead>
                <tr>
                  <th scope="col">CLIENTE</th>
                  <th scope="col">FECHA</th>
                  <th scope="col">PRECIO</th>
                  <th scope="col">DESC. (%)</th>
                  <th scope="col">DESC. ($)</th>
                  <th scope="col">COBRADO</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="tirar-izq"
                  v-for="venta in model.list"
                  :key="venta.id"
                >
                  <th class="tirar-izq" scope="row">
                    {{ venta.nombreCliente }}</th>
                  <td class="tabla-historial__columna-centrada">
                    {{ venta.fecha}}
                  </td>
                  <td class="tabla-historial__columna-centrada">
                    {{ venta.precio }}
                  </td>
                  <td class="tabla-historial__columna-centrada">
                    {{ venta.porcentajeDescuento }}
                  </td>
                  <td class="tabla-historial__columna-centrada">
                    {{ venta.montoDescontado }}
                  </td>
                  <td class="tabla-historial__columna-centrada">
                    {{ venta.montoCobrado }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="resultados-historial">
            <div>
              <label>LLEVAS VENDIDO</label>
              <span>{{ model.totalVendido }}</span>
            </div>
            <div>
              <label>DESCUENTOS OTORGADOS</label>
              <span>{{ model.totalDescontado }}</span>
            </div>
            <div>
              <label>TOTAL COBRADO</label>
              <span>{{ model.totalCobrado }}</span>
            </div>
          </div>
        </div>
        <div class="ventas-no-registradas" v-else>
          Todavía no tienes ventas registradas
        </div>
      </div>
      <div v-else>Cargando...</div>
      <button @click="clickGoBack()" class="btn-volver">
        <FontAwesomeIcon :icon="Icons.VOLVER" />
        VOLVER
      </button>
    </div>
  </div>
</template>
<script>
const URL_IMAGEN_PRINCIPAL = "img/logo-corazon-historial.svg";
const ICO_FLECHA_IZQ_URL = "img/ico-flecha-izq.svg";
const ICO_CUNIA_URL = "img/ico-cunia-select.svg";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Icons as IconConstants } from "../../constants";
import { ComercianteService } from "../../servicios/comerciante.service";
import { Util } from "../../util";
import { RouteNames } from '../../routes/comerciante.routes';


export default {
  components: {
    FontAwesomeIcon,
  },
  data() {
    return {
      urlFlecha: null,
      urlCunia: null,
      navegador: null,
      model: {
        urlImagenPrincipal: URL_IMAGEN_PRINCIPAL,
        startDate: undefined,
        endDate: undefined,
        loading: true,
        isEmpty: false,
        list: undefined,
        totalVendido: undefined,
        totalDescontado: undefined,
        totalCobrado: undefined,
      },
    };
  },
  computed: {
    Icons() {
      return IconConstants;
    },
  },
  methods: {
    checkearNavegador() {
      this.navegador = navigator.userAgent.search("Firefox");
      let a = false;
      if (this.navegador > -1) {
        a = true;
      }
      return a;
    },
    borrarCunia(i) {
      var lista = document.getElementsByClassName("cunia");
      if (this.checkearNavegador()) {
        lista[i].style.display = "none";
      }
    },
    mostrarFechaDesde() {
      document.getElementById("fecha-desde").style.color = "white";
      this.borrarCunia(0);
    },
    mostrarFechaHasta() {
      document.getElementById("fecha-hasta").style.color = "white";
      this.borrarCunia(1);
    },
    clickGoBack() {
      this.$router.push({ name: RouteNames.Ventas });
    },
    clickHome() {
      this.$router.push({ name: RouteNames.Ventas });
    },
    formatList(listDto) {
      const modelList = [];

      for (const ventaDto of listDto) {
        const montoDescontado =
          (ventaDto.precioBase * ventaDto.porcentajeDescuento) / 100;
        const montoCobrado = ventaDto.precioBase - montoDescontado;

        const ventaModel = {
          id: ventaDto.id,
          nombreCliente: ventaDto.nombreCliente,
          fecha: ventaDto.fecha,
          precio: Util.formatMoney(ventaDto.precioBase),
          porcentajeDescuento: ventaDto.porcentajeDescuento.toString() + "%",
          montoDescontado: Util.formatMoney(montoDescontado),
          montoCobrado: Util.formatMoney(montoCobrado),
        };

        modelList.push(ventaModel);
      }

      return modelList;
    },
    getListAndTotals() {
      return ComercianteService.getVentaListAndTotalsWithFilter({
        // Ya son ISO strings
        startDateIsoString: this.model.startDate,
        endDateIsoString: this.model.endDate,
      });
    },
    loadData() {
      this.model.loading = true;

      this.getListAndTotals()
        .then((response) => {
          const data = response.data;
          const list = data.list;

          if (list && list.length) {
            this.model.list = this.formatList(list);
            this.model.isEmpty = false;
          } else {
            this.model.isEmpty = true;
            this.model.list = undefined;
          }

          const totalVendido =
            Number(data.totalCobrado) + Number(data.totalDescontado);

          this.model.totalDescontado = Util.formatMoney(data.totalDescontado);
          this.model.totalCobrado = Util.formatMoney(data.totalCobrado);
          this.model.totalVendido = Util.formatMoney(totalVendido);
        })
        .finally(() => (this.model.loading = false));
    },
    startDateChanged() {
      this.loadData();
    },
    endDateChanged() {
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
    this.urlFlecha = ICO_FLECHA_IZQ_URL;
    this.urlCunia = ICO_CUNIA_URL;
  },
};
</script>
<style lang="scss">
$ancho-historial: 845px;

.cuerpo-historial {
  background-color: #002135;
  display: flex;
  flex-direction: column;
  align-items: center;
  .btn-inicio-hisotrial {
    width: $ancho-historial;
    button {
      background: transparent;
      color: var(--color-estructura-c);
      font-size: 16px;
      line-height: 18px;
      margin-top: 20px;
      display: flex;
      justify-self: left;
      align-self: center;
      img {
        width: 19px;
        bottom: 1px;
        margin-right: 5px;
        position: relative;
        align-self: center;
      }
    }
  }
  .contenedor-datos {
    display: flex;
    flex-direction: column;
    align-items: center;
    .logo-historial {
      margin-top: 22px;
      width: 188px;
      margin-bottom: 31px;
    }
    .titulo {
      width: $ancho-historial;
      font-weight: 700;
      height: 45px;
      font-size: 24px;
      color: white;
      line-height: 28px;
      border-top: 1px solid white;
      border-bottom: 1px solid white;
      // width: 80%;
      text-align: center;
      padding-top: 9px;
      margin-bottom: 28px;
    }

    .fecha-historial {
      display: flex;
      flex-direction: row;
      justify-content: center;
      column-gap: 214px;
      & > div {
        width: 108px;
      }

      input {
        background: transparent;
        color: white;
        border-bottom: 1px solid white;
        border-top: none;
        border-left: none;
        border-right: none;
        border-radius: 0;
        font-size: 12px;
        padding-left: 0;
        padding-right: 0;
      }
      input[type="date"]::-webkit-calendar-picker-indicator {
        background: transparent;
        color: transparent;
        height: 30px;
        width: 100px;
        transform: translateX(-23%);
        position: absolute;
      }
      input:not(input:focus-within) {
        color: var(--color-estructura-a);
      }
      input[type="date"]::-moz-clear {
        display: none;
      }
      .box-fecha {
        display: flex;
        flex-direction: row;
        img {
          position: relative;
          right: 8px;
        }
      }
      label {
        color: white;
        text-align: left;
        width: 100%;
        font-size: 16px;
      }
    }

    .table-responsive {
      justify-content: center !important;
      display: flex !important;
    }

    .tabla-historial {
      color: white;
      width: $ancho-historial;
      thead {
        th {
          border: none;
          color: #baece9;
        }
      }
      tbody {
        th,
        td {
          border-bottom: 2px dotted white !important;
          border-top: none;
        }
      }
      .tirar-izq {
        text-align: left;
        padding-left: 10px;
      }
    }

    .tabla-historial__columna-centrada {
      text-align: center;
    }

    .resultados-historial {
      display: flex;
      flex-direction: row;
      column-gap: 56px;
      div {
        label {
          color: #baece9;
          font-weight: 700;
          margin-top: 55px;
          margin-bottom: 3px;
        }
        span {
          color: var(--color-estructura-a);
          width: 280px;
          height: 40px;
          line-height: 28px;
          padding-top: 7px;
          display: block;
          text-align: center;
          background: white;
          border-radius: 2px;
          font-size: 24px;
          font-family: "roboto-700" !important;
        }
      }
    }

    .btn-volver {
      margin-top: 32px;
      margin-bottom: 81px;
      width: 274px;
      height: 48px;
      font-size: 16px;
      font-weight: 700;
      line-height: 18px;
      color: white;
      border-radius: 6px;
      background: var(--color-estructura-c);
      box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    }
  }

  .ventas-no-registradas {
    margin-top: 20px;
    color: var(--color-estructura-c);
  }
}
@media screen and (min-width: 2px) and (max-width: 500px) {
  .cuerpo-historial {
    .contenedor-datos {
      .logo-historial {
        width: 30vw;
      }
      .titulo {
        font-size: 5vw;
      }
      .table-responsive {
        .tabla-historial {
          width: 600px;
        }
      }
    }
  }
}

@media screen and (min-width: 501px) and (max-width: 700px) {
  .contenedor-datos {
    .tabla-historial {
      width: 845px;
    }
  }
}
@media screen and (max-width: 1000px) and (min-width: 701px) {
  .tabla-historial {
    width: 90vw;
  }
}

@media screen and (max-width: 1000px) {
  .cuerpo-historial {
    .contenedor-datos {
      .btn-inicio-hisotrial {
        width: 100%;
      }
      .titulo {
        width: 90vw;
      }
      .fecha-historial {
        column-gap: 10vw;
      }
      .table-responsive {
        display: block !important;
        width: 90vw;
        .tabla-historial {
          overflow-x: scroll;
        }
      }
      .resultados-historial {
        flex-direction: column;
        align-items: center;
        div {
          label {
            margin-top: 24px;
          }
        }
      }
    }
  }
}

@media screen and (min-height: 827px) {
  .cuerpo-historial {
    .contenedor-datos {
      .btn-volver {
        margin-bottom: 20vh;
      }
    }
  }
}
</style>
